// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import store from "./store/index"
import {getParamsFromUrl, makeUrl} from "./lib/util";

Vue.config.productionTip = false


let query = url("?", location.href),
  options = getParamsFromUrl(location.href);
if (query && query.version) {
  init();
} else {
  query = Object.assign({}, query, {versin: window.version});
  location.replace(makeUrl(Object.assign({}, options, {query})));
}


//oauth2(init);
init();


function init() {
  /* eslint-disable no-new */
  new Vue({
    el: '#app',
    router,
    store,
    template: '<App/>',
    components: {App}
  })
}



// WEBPACK FOOTER //
// ./src/main.js